import React, { useEffect, useState } from 'react';
import { useCoverLetter } from '../../../context/CoverLetterContext';
import WpAPI from '../../../WpApi';
import LoadingIcon from '../../../images/spinner.svg';
import { stripTags } from '../../../helper';

const JobForm = ({ data, save }) => {
    const [checkField, setCheckField] = useState('');
    const [loading, setLoading] = useState(false);
    const [matchedTitles, setMatchedTitles] = useState([]);
    const fieldFocus = e => {
        setCheckField(e.target.name);
        // removeError(e);
    }
    const fieldBlur = e => {
        setCheckField('');
    }
    const jobSelected = (v) => {
        save({ desired_position: v });
        setMatchedTitles([])
    }

    return (
        <div className="screen-block">
            {/* //Duplicate screen start  */}
            <div className="form-row">
                <div className="field-wrap">
                    <label htmlFor="desired_position" className={`label${checkField == 'desired_position' ? ' label-focus' : ''}`}>Desired Position</label>
                    <input
                        type="text"
                        className="validate add-top-margin"
                        name="desired_position"
                        id="desired_position"
                        placeholder="Customer Service Representative"
                        value={data.desired_position}
                        onChange={(e) => {
                            if (e.target.value.trim().length > 2) {
                                setLoading(true)
                                WpAPI.getJobTitles(e.target.value.trim()).then(res => {
                                    setMatchedTitles(res)
                                    setLoading(false)
                                })
                            }else if(e.target.value.length == 0){
                                setMatchedTitles([])

                            }
                            save({ desired_position: stripTags(e.target.value) });
                        }}
                        onFocus={(e) => fieldFocus(e)}
                        onBlur={(e) => {
                            if(e.target.value.length == 0) setMatchedTitles([])
                            fieldBlur(e)
                        }}
                    />
                    <div className="load-listing">{loading ? <LoadingIcon /> : ""}</div>
                    {matchedTitles.length > 0 && <>
                        <div className="load-listing close-listing" onClick={()=>setMatchedTitles([])}>{loading ? "" : <i className='icon-cross-icon'></i>}</div>
                        <div className="job-list">
                            <ul>
                                {matchedTitles.map((v, n) => <li key={n} onClick={() => jobSelected(v)}><span>{v}</span></li>)}
                            </ul>
                        </div></>}
                </div>
                <div className="field-wrap">
                    <label htmlFor="desired_company" className={`label${checkField == 'desired_company' ? ' label-focus' : ''}`}>Desired Company/Organization</label>
                    <input
                        type="text"
                        className="validate add-top-margin"
                        name="desired_company"
                        id="desired_company"
                        placeholder="Desired Company/Organization"
                        defaultValue={data.desired_company}
                        onChange={(e) => {
                            save({ desired_company: stripTags(e.target.value) });
                        }}
                        onFocus={(e) => fieldFocus(e)}
                        onBlur={(e) => fieldBlur(e)}
                    />
                </div>
            </div>
            {/* //Duplicate screen start  */}
        </div>)

}

export default JobForm;